import { IMAGE_SLOTS } from "@/content/siteContent";

/* Image slots — authentic photographs (Phase 2) or labelled placeholders.
   Real photographs render at their natural aspect ratio (idols are never
   force-cropped), lazy-load below the fold and carry a restrained
   hover-drift on desktop. To add a new photograph, set its `src` (and
   `alt`) in IMAGE_SLOTS in src/content/siteContent.js. */
export const ImageSlot = ({ slotKey, aspect = "4 / 3", light = false, caption, className = "" }) => {
    const slot = IMAGE_SLOTS[slotKey];

    if (slot?.src) {
        const variant = slot.variant ? ` img-frame--${slot.variant}` : "";
        return (
            <figure className={`photo-figure ${className}`} data-testid={`photo-${slotKey}`}>
                <div
                    className={`img-frame${variant}`}
                    style={slot.focus ? { "--focus": slot.focus } : undefined}
                >
                    <img
                        src={slot.src}
                        alt={slot.alt || slot.label}
                        loading="lazy"
                        className="img-live"
                    />
                </div>
                {caption && (
                    <figcaption className="photo-caption" data-testid={`photo-caption-${slotKey}`}>
                        {caption}
                    </figcaption>
                )}
            </figure>
        );
    }

    return (
        <div
            role="img"
            aria-label={`${slot?.label || "Photograph"} — to be added`}
            data-testid={`image-slot-${slotKey}`}
            className={`image-slot ${light ? "image-slot--light" : ""} flex flex-col items-center justify-center gap-3 rounded-sm px-6 text-center ${className}`}
            style={{ aspectRatio: aspect }}
        >
            <svg
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                aria-hidden="true"
                className={light ? "text-[#A51C30]/50" : "text-[#C8A15A]/50"}
            >
                <circle cx="22" cy="22" r="20" stroke="currentColor" strokeWidth="1" />
                <circle cx="22" cy="22" r="13" stroke="currentColor" strokeWidth="1" strokeDasharray="3 4" />
                <circle cx="22" cy="22" r="5" stroke="currentColor" strokeWidth="1" />
            </svg>
            <p
                className={`font-display text-lg italic ${
                    light ? "text-[#A51C30]/80" : "text-[#C8A15A]/80"
                }`}
            >
                {slot?.label}
            </p>
            <p
                className={`text-[0.68rem] uppercase tracking-[0.22em] ${
                    light ? "text-[#2b1418]/45" : "text-[#FFF5E6]/40"
                }`}
            >
                Original photograph — to be added
            </p>
        </div>
    );
};
